var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5078 6.80603V11.684H11.5638V7.86203H31.6158V32.138H11.5638V15.188H10.5078V33.194H32.6718V6.80603H10.5078Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9258 28.292H25.2858V27.236H27.9258V28.292ZM22.6458 28.292H15.2598V27.236H22.6458V28.292ZM27.9258 25.124H25.2858V24.068H27.9258V25.124ZM22.6458 25.124H15.2598V24.068H22.6458V25.124ZM27.9258 21.956H25.2858V20.9H27.9258V21.956ZM22.6458 21.956H15.2598V20.9H22.6458V21.956Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9258 18.5421H25.2858V17.4861H27.9258V18.5421ZM22.6458 18.5421H15.2598V17.4861H22.6458V18.5421Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8898 13.946H18.9678V12.89H27.8898V13.946Z",
    fill: "#F69D25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3419 13.3461L14.3779 16.3581C14.2039 16.5321 13.9279 16.5321 13.7539 16.3581C13.5799 16.1841 13.5799 15.9081 13.7539 15.7341L15.6559 13.7841H7.76588C7.51988 13.7841 7.32788 13.5861 7.32788 13.3461C7.32788 13.1061 7.52588 12.9081 7.76588 12.9081H15.6559L13.5799 10.8201C13.4059 10.6461 13.4059 10.3701 13.5799 10.1961C13.7539 10.0221 14.0299 10.0221 14.2039 10.1961L17.3419 13.3461Z",
    fill: "#F69D25"
  })));
}

export default SvgList;